export default __webpack_public_path__ + "static/media/20.e063b561.jpg";